import React from "react";
import PageSuccess from "./success";
import PageRegister from "./registration";
import PageError from "./error";
import LandingPage from "../landing/landing";
import ieSvg from "../../components/icons/ieSvg";
import {userAction} from "../../store/actions/userAction";
import {connect} from "react-redux";
import * as consts from "../../store/constants/userInfo";
import PageLoading from "../server/preload";


class PageStart extends React.Component {
  componentDidMount() {
    document.title = "Стать самозанятым | FBalance";
    ieSvg();
    const splitGateURL = process.env.REACT_APP_GATE.split('/');
    this.versionGate = splitGateURL[splitGateURL.length - 2].substring(1)*1;
    if (this.versionGate === 1 || this.props.clientInfo.items) return;
    this.props.fetchData(process.env.REACT_APP_GATE + "client/info", this, consts.CLIENT_INFO);
  }

  handleClick = () => {
    this.props.fetchData(process.env.REACT_APP_GATE + "client/registration/restriction", this, consts.CLIENT_REGISTRATION_RESTRICTION);
  }

  checkFormatPassport = () => {
    let seria = this.props.clientInfo.items.data.passportSeries,
        number = this.props.clientInfo.items.data.passportNumber;
    seria = seria?.length === 4 && Number.isInteger(seria*1);
    number = number?.length === 6 && Number.isInteger(number*1);
    return seria && number;
  }

  render() {
    if (this.props.data.items) {
      switch (this.props.data.items.result.status) {
        case "AUTH_FAILED":
          window.location = process.env.REACT_APP_ELF_URL + '?login=true';
          return false;
        case "ERROR":
          return <PageError
            infoTitle='Что-то пошло не так'
            infoMessage={this.props.data.items.result.errorMessage}
            infoLink={process.env.REACT_APP_ELF_URL}
            infoButton="Вернуться в интернет-банк"
          />;
        case "TIMEOUT":
          return <PageError
            infoTitle='Что-то пошло не так'
            infoMessage='Сервис временно недоступен, повторите операцию позже.'
            infoLink={process.env.REACT_APP_ELF_URL}
            infoButton="Вернуться в интернет-банк"
          />;
        default:
          if (this.props.data.items.data) {
            switch (this.props.data.items.data.value) {
              case "NOT_FOUND":
                return <PageRegister regType="passport" />;
              case "ERROR":
                return <PageError
                  infoTitle='Что-то пошло не так'
                  infoMessage={this.props.data.items.data.errorMessage}
                  infoLink={process.env.REACT_APP_ELF_URL}
                  infoButton="Вернуться в интернет-банк"
                />;
              case "DENY":
                if (this.props.data.items.data.errorCode === "REGISTERED") {
                  return <PageSuccess
                    infoTitle='Заявление успешно отправлено'
                    infoMessage={<div>Ваши данные направлены в Федеральную налоговую службу для регистрации статуса
                      самозанятого.<br/>
                      Как только статус будет подтверждён, вы получите доступ к личному кабинету.</div>}
                    infoButton="Вернуться в Интернет банк"
                    infoLink={process.env.REACT_APP_ELF_URL}
                    reloadButton="Проверить статус"
                  />;
                } else {
                  if (this.versionGate === 1 || this.checkFormatPassport()) {
                    return <PageRegister regType="passport" />;
                  } else {
                    return <PageError
                      infoTitle="В регистрации отказано"
                      infoErrorMessage={this.props.data.items.data.errorMessage}
                      updateButton="Закрыть"
                    />;
                  }
                }
              case "ALLOW":
                return <PageRegister regType="inn"/>;
              default:
                return <LandingPage handleClick={this.handleClick.bind(this)}/>
            }
          }
          else {
            return <PageLoading />
          }

      }
    }
    else {
      return <LandingPage handleClick={this.handleClick.bind(this)}/>
    }
  }
}

const mapStateToProps = state => ({data: state.clientRegistrationRestriction, clientInfo: state.clientInfo})

const mapDispatchToProps = dispatch => {
  return {fetchData: (url, parent, types) => dispatch(userAction(url, parent, types))}
}

export default connect(mapStateToProps, mapDispatchToProps)(PageStart);